import {TrackingEvent as CollapsibleTrackingEvent} from 'common/components/section/tracking';
import {TRACKING_EVENTS as CustomPropertyModalTrackingEvent} from 'common/widgets/custom-property-modal/constants';
import {TRACKING_EVENTS as QueryBlockTrackingEvent} from 'common/query-builder/query-block/constants';
import {
  FlattenedResourceTrackingEvent,
  QueryEntrySectionTrackingEvent as EventSectionTrackingEvent,
} from 'common/query-builder/query-entry-section/tracking';
import {TrackingEvent as PropertiesMenuTrackingEvent} from 'common/query-builder/query-block/properties-menu/tracking';

export enum TrackingEvent {
  AddPropertyFilter = `[mp-query-builder] Add property filter`,
  AddSegment = `[mp-query-builder] Add segment`,
  ClearSegment = `[mp-query-builder] Clear segment`,
  EditPropertyFilter = `[mp-query-builder] Edit property filter`,
  EditSegment = `[mp-query-builder] Edit segment`,
  RemovePropertyFilter = `[mp-query-builder] Remove property filter`,
  RemoveSegment = `[mp-query-builder] Remove segment`,
  ReorderSegment = `[mp-query-builder] Reorder segment`,
  SelectDateRange = `[mp-query-builder] Select date range`,
  SelectSegment = `[mp-query-builder] Select segment`,
  SelectBreakdownAttribution = `[mp-query-builder] Select breakdown attribution`,
  SelectFunnelsBreakdownAttribution = `[mp-query-builder] Select funnels breakdown attribution`,
}

/** Defines tracking events that will be tracked as part of the query-builder */
export const CAPTURED_TRACKING = new Set<string>([
  CollapsibleTrackingEvent.ClosedCollapsibleSection,
  CollapsibleTrackingEvent.OpenedCollapsibleSection,
  TrackingEvent.ReorderSegment,
  ...FlattenedResourceTrackingEvent,
  ...Object.values(EventSectionTrackingEvent),
  ...Object.values(PropertiesMenuTrackingEvent),
  ...Object.values(CustomPropertyModalTrackingEvent),
  ...Object.values(QueryBlockTrackingEvent),
]);
